export default __webpack_public_path__ + "static/media/administrador.35bc8f46.png";